import {
    useEffect,
    useState,
} from 'react';
import {TestObservationsFilter} from '../types';

// Module-scoped filter store (global-filter-store-pattern). The Filter button (which
// shows the active-count badge), the filter drawer and the list hook are separate
// components and must observe the same filter — same reasoning as the FNP-815
// keyword store.
//
// Only the four TestObservationsFilterInput fields are supported server-side:
//   syntheticUserId, actionCode, outcome, verificationResult
// No default filter is seeded — an admin opening the page sees everything, then
// narrows to FAIL (the primary triage move).
let globalFilters: TestObservationsFilter = {};
const filterListeners: Set<(filters: TestObservationsFilter) => void> = new Set();

const notifyFilterChange = (filters: TestObservationsFilter) => {
    globalFilters = filters;
    filterListeners.forEach(listener => listener(filters));
};

export const useTestObservationsFilter = () => {
    const [filters, setFilters] = useState<TestObservationsFilter>(globalFilters);

    useEffect(() => {
        const listener = (newFilters: TestObservationsFilter) => {
            setFilters(newFilters);
        };
        filterListeners.add(listener);
        setFilters(globalFilters);
        return () => {
            filterListeners.delete(listener);
        };
    }, []);

    const handleSetFilters = (newFilters: TestObservationsFilter) => {
        // Drop empty values at the edge so the active-count badge counts only
        // filters that actually narrow anything.
        const clean = Object.entries(newFilters)
                            .reduce((acc: Record<string, string>, [key, value]) => {
                                if (typeof value === 'string' && value.trim() !== '') {
                                    acc[key] = value.trim();
                                }
                                return acc;
                            }, {});
        notifyFilterChange(clean);
    };

    const handleClearFilters = () => {
        notifyFilterChange({});
    };

    return {
        filters,
        activeCount: Object.keys(filters).length,
        handleSetFilters,
        handleClearFilters,
    };
};
